export class AUTHGWCONSTANTS {
    public static bearerToken: string = '&YTITTFYMk6ro76ro86' + window.location.hostname;
    public static xOriginKey: string = '&76itp7uy;09u;ogb.iugto7ik6rfv' + window.location.hostname;
    public static xApiKey: string = '&o87uh;ugli.uglgkugjkhgllioyuil' + window.location.hostname;
    public static serAccKey: string = '&i76yrol87t50liluyto87' + window.location.hostname;
    public static phoneNumber: string = '';
    public static email: string = '';
}

export const AUTHORIZATION_TOKEN = [];
